import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 30px;

  h3 {
    margin-top: 26px;
  }
`;

export const CompanyDetails = styled.div`
  margin: 26px 0;
  display: flex;
  width: 100%;
  grid-column-gap: 32px;
  flex-wrap: wrap;
  border-bottom: 1px solid #ccecf9;
`;

export const DetailWrapper = styled.div`
  width: 48%;
  color: #00202d;
  margin-bottom: 26px;

  img {
    margin-top: 0;
    width: auto;
  }
  @media only screen and (max-width: 563px) {
    width: 100%;
    img {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const Header = styled.p`
  margin-bottom: 10px;
  font-size: ${fontSize(13)};
  font-weight: bold;
  line-height: 1.67;
  letter-spacing: -0.18px;
`;
export const Content = styled.p`
  font-size: ${fontSize(16)};
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: -0.24px;
  max-width: 415px;
`;

export const Address = styled.div`
  display: flex;
  width: 100%;
  grid-column-gap: 32px;
  flex-wrap: wrap;
  border-bottom: 1px solid #ccecf9;
`;

export const CompanyLogo = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 420px;
  height: 256px;
  margin-bottom: 56px;

  @media only screen and (max-width: 563px) {
    width: 100%;
  }
`;

export const Description = styled.div`
  font-family: Barlow;
  font-size: ${fontSize(16)};
  font-weight: normal;
  line-height: 1.5;
  letter-spacing: -0.24px;
  color: #00202d;

  ul,
  ol {
    margin-top: 15px;
    margin-bottom: 40px;

    li {
      display: flex;
      align-items: flex-start;
      padding: 8px 0 8px 14px;
      position: relative;

      &::before {
        position: absolute;
        left: 0;
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #e6007e;
        margin: 10px 10px 0 0;
      }
    }
  }
`;
